import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { customerDetailsUpdateMobilePatch } from '../../../../api-client/api-gqadmin-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const patchCustomerDetailsMobileUpdate = createAsyncThunk(
    'patchCustomerDetailsMobileUpdate/Patch',
    async (body, { rejectWithValue }) => {
        try {
            const response = await customerDetailsUpdateMobilePatch(body);
            const data = response.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'PATCH_GQ_CUSTOMER_DETAILS_UPDATE_MOBILE_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

export const patchCustomerDetailsMobileUpdateSlice = createSlice({
    name: 'patchCustomerDetailsMobileUpdate',
    initialState,
    extraReducers: {
        [patchCustomerDetailsMobileUpdate.pending]: (state) => {
            state.loading = true;
        },
        [patchCustomerDetailsMobileUpdate.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
        },
        [patchCustomerDetailsMobileUpdate.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const patchCustomerDetailsMobileUpdateSelector = (state) => state.patchCustomerDetailsMobileUpdate;
export const patchCustomerDetailsMobileUpdateReducer = patchCustomerDetailsMobileUpdateSlice.reducer;
